module.exports = __webpack_public_path__ + "196e4f546bef08d73cc982b6fb2fe0aa.png";